/* global axios */
import AsteriskApiClient from './index';

class ExtensionsAPI extends AsteriskApiClient {
  constructor() {
    super('extensions');
  }

  // GET /api/v1/accounts/:account_id/asterisk/extensions
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/asterisk/extensions/:id
  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/extensions
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/asterisk/extensions/:id
  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/extensions/:id
  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }

  // GET /api/v1/accounts/:account_id/asterisk/extensions/check_availability?extension=XXX
  checkAvailability(extension) {
    return axios.get(`${this.url}/check_availability`, {
      params: { extension },
    });
  }
}

export default new ExtensionsAPI();
